module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Phone-3695ce1e3c55ce2013256da9812a1a6b.png";